export const login = (data) => ({
  method: 'POST',
  url: '/auth/login',
  data
})

export const signup = (data) => ({
  method: 'POST',
  url: '/auth/signup',
  data
})

export const sendReferral = (data) => ({
  method: 'POST',
  url: '/referrals/send',
  data
})

export const forgotPassword = (data) => ({
  method: 'POST',
  url: '/auth/password/forgot',
  data
})

export const changePassword = (data) => ({
  method: 'POST',
  url: '/auth/password/change',
  data
})

export const recoverPasssword = (data) => ({
  method: 'POST',
  url: '/auth/password/recover',
  data
})

export const verifyAccount = (data) => ({
  method: 'POST',
  url: '/verify',
  skipAuth: false,
  prefix: ' ',
  data
})

export const generateTwoFactor = (data) => ({
  method: 'POST',
  url: '/auth/two-factor/generate',
  data
})

export const verifyTwoFactor = (data) => ({
  method: 'POST',
  url: '/auth/two-factor/verify',
  data
})

export const disableTwoFactor = (data) => ({
  method: 'POST',
  url: '/auth/two-factor/disable',
  data
})

export const respondChallenge = (data) => ({
  method: 'POST',
  url: '/auth/challenges/respond',
  data
})

export const resendVerificationCode = (data) => ({
  method: 'POST',
  url: '/auth/verify-account/resend',
  data
})

export const getSession = (data) => ({
  method: 'POST',
  url: '/session/get',
  data
})